import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import {
  createReducer,
  getArrayAfterAsyncCall,
  updateArrayItemAfterAsyncCall,
} from '@topconagriculture/frontend-utils';

import { createOperator, deleteOperator, getAllOperators, getOperatorsList, updateOperator } from './operators.actions';
import { Operator } from '../../../core/api/operator/operator.types';

export type OperatorState = Operator[];

export const initialState: OperatorState = [];

const operatorsReducer = createReducer(initialState, {
  [getOperatorsList.done.type]: (state: OperatorState, action: ReturnType<typeof getOperatorsList.done>) =>
    [...state, ...action.payload.result].sort((o1, o2) => o1.name.toLowerCase().localeCompare(o2.name.toLowerCase())),
  [getAllOperators.done.type]: (state: OperatorState, action: ReturnType<typeof getAllOperators.done>) =>
    getArrayAfterAsyncCall<Operator>(state, action).sort((o1, o2) =>
      o1.name.toLowerCase().localeCompare(o2.name.toLowerCase()),
    ),
  [createOperator.done.type]: (state: OperatorState, action: ReturnType<typeof createOperator.done>) => [
    ...state,
    action.payload.result,
  ],
  [deleteOperator.done.type]: (state: OperatorState, action: ReturnType<typeof deleteOperator.done>) => {
    const deletedId = action.payload.params.id;
    const indexFound = state.findIndex((operator: Operator) => operator.id === deletedId);
    return dotProp.delete(state, indexFound);
  },
  [updateOperator.done.type]: (state: OperatorState, action: Action<any>) =>
    updateArrayItemAfterAsyncCall<Operator>(state, action),
});

export default operatorsReducer;
